import { calculateDelayDays } from '@/helpers'

import styles from './table-shipment-invoice.module.css'

export const getExpectedPaidClasses = (
  date?: string,
  paymentAt?: string,
): string => {
  if (!date) {
    return ''
  }

  const delayDays = calculateDelayDays(
    new Date(date),
    paymentAt ? new Date(paymentAt) : new Date(),
  )

  if (delayDays > 0 && delayDays <= 3) {
    return styles['text-warning']
  }

  if (delayDays > 3) {
    return styles['text-danger']
  }

  return ''
}
